module.exports = __webpack_public_path__ + "img/airtrek.c46a3e7a.png";